module.exports = __webpack_public_path__ + "h5/img/01@2x.b5cd471a.png";